import {
  AGREEMENT_TYPE,
  THIRD_PARTY_REGISTRATION,
} from '../pages/SpecialBilling/config/constants';
import { uploadSpecialAgreementFile } from '../services/apis';
import { fileToBase64 } from './file';

export const uploadFiles = async (values, setFieldValue) => {
  const files = values.agreementDocument;

  if (!files || files.length === 0) {
    return Promise.resolve(true);
  }
  files?.map((va, i) => {
    if (!files[i].fileId) {
      files[i].uploading = true;
      files[i].uploadTried = true;
    }
  });
  setFieldValue('agreementDocument', files ?? []);
  const promises = files.map(async (file) => {
    if (!file.fileId && !file.url) {
      const fileBase = await fileToBase64(file);
      return uploadSpecialAgreementFile(
        fileBase,
        file.name,
        file.type.split('/')[1],
      );
    }
    return Promise.resolve(true);
  });

  const results = await Promise.allSettled(promises);
  let isSuccessfullUpload = true;
  results.map((va, i) => {
    if (!files[i].fileId && !files[i].url) {
      if (va.status === 'fulfilled') {
        files[i].successfulUpload = true;
        files[i].fileId = va.value.data.fileId;
      } else {
        isSuccessfullUpload = false;
      }
      files[i].uploading = false;
    }
  });

  setFieldValue('agreementDocument', files);

  return Promise.resolve(isSuccessfullUpload);
};

export const mapSpecialBillingAgreementToFormValues = (
  mapped,
  agreement,
  agreementType,
) => {
  const thirdPartyId = mapped.thirdPartyId ?? agreement.thirdPartyId ?? '';
  return {
    buyerVatNumber: mapped.buyerId ?? agreement.buyerId,
    sellerVatNumber: mapped.sellerId ?? agreement.sellerId,
    thirdPartyVatNumber: thirdPartyId.length > 10 ? thirdPartyId : '',
    thirdPartyRegistered:
      agreementType === AGREEMENT_TYPE.THIRD
        ? thirdPartyId.length == 10
          ? THIRD_PARTY_REGISTRATION.NOT_VAT_REGISTERED
          : THIRD_PARTY_REGISTRATION.VAT_REGISTERED
        : '',
    note: mapped.details ?? agreement.details,
    agreementStartDate: mapped.startDate ?? agreement.startDate,
    agreementEndDate: mapped.endDate ?? agreement.endDate,
    referenceNumber: mapped.referenceNumber ?? agreement.referenceNumber,
    buyerName: mapped.buyerName ?? agreement.buyerName,
    buyerEmail: mapped.buyerEmail ?? agreement.buyerEmail,
    buyerPhoneNumber: mapped.buyerPhoneNumber ?? agreement.buyerPhoneNumber,
    sellerPhoneNumber: mapped.sellerPhoneNumber ?? agreement.sellerPhoneNumber,
    sellerName: mapped.sellerName ?? agreement.sellerName,
    sellerEmail: mapped.sellerEmail ?? agreement.sellerEmail,
    thirdPartyName: mapped.thirdPartyName ?? agreement.thirdPartyName,
    thirdPartyEmail: mapped.thirdPartyEmail ?? agreement.thirdPartyEmail,
    thirdPartyPhoneNumber:
      mapped.thirdPhoneNumber ?? agreement.thirdPhoneNumber,
    thirdPartyTinNumber: thirdPartyId.length == 10 ? thirdPartyId : '',
    // map the agreement document into agreementDocument if there are values in mapped.agreementFilesDtoList, otherwise use the existing agreement.agreementFilesDtoList
    agreementDocument:
      mapped.agreementFilesDtoList?.length > 0
        ? mapped.agreementFilesDtoList
            .map((file) => ({
              fileId: file.fileId,
              name: file.fileName,
              size: file.fileSize,
              url: file.fileUrl,
            }))
            .filter((file) => file.url) // filter out files that don't have a url
        : agreement.agreementFilesDtoList
            ?.map((file) => ({
              fileId: file.fileId,
              name: file.fileName,
              size: file.fileSize,
              url: file.fileUrl,
            }))
            .filter((file) => file.url) ?? [],
  };
};
